import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const MINIMUM_VISIBLE_ITEMS_DEFAULT = 3;

export class ExpandableList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewMoreButtonPosition: props.itemCount,
      isViewMoreButtonPositionEstablished: false,
      isViewMoreButtonDismissed: false,
      isViewMoreButtonHidden: false,
      isClient: false
    };
  }

  canShowViewMoreButton = () =>
    this.state.isClient &&
    !this.state.isViewMoreButtonDismissed &&
    !this.state.isViewMoreButtonHidden;

  isElementInFirstLine = elem =>
    elem.offsetTop === elem.parentNode.children[0].offsetTop;

  onViewMoreButtonClicked() {
    this.setState({
      isViewMoreButtonDismissed: true
    });
  }

  componentDidMount() {
    this.setState({ isClient: true });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { width: oldWidth } = this.props.screenDimensions;
    const { width: newWidth } = nextProps.screenDimensions;
    if (newWidth !== oldWidth || nextProps.itemCount !== this.props.itemCount) {
      this.setState({
        viewMoreButtonPosition: this.props.itemCount,
        isViewMoreButtonPositionEstablished: false,
        isViewMoreButtonHidden: false
      });
    }
  }

  hasStateChanged = nextState =>
    this.state.viewMoreButtonPosition !== nextState.viewMoreButtonPosition ||
    this.state.isViewMoreButtonDismissed !==
      nextState.isViewMoreButtonDismissed ||
    this.state.isViewMoreButtonHidden !== nextState.isViewMoreButtonHidden;

  haveItemsChanged = nextProps => nextProps.itemCount !== this.props.itemCount;

  shouldComponentUpdate = (nextProps, nextState) => {
    if (this.state.isViewMoreButtonDismissed) {
      return false;
    }

    if (
      !nextState.isViewMoreButtonPositionEstablished ||
      this.hasStateChanged(nextState) ||
      this.haveItemsChanged(nextProps)
    ) {
      return true;
    }

    return false;
  };

  areAllItemsInFirstLine = () =>
    this.state.viewMoreButtonPosition === this.props.itemCount &&
    this.isElementInFirstLine(this.viewMoreButton.previousSibling);

  canMoveViewMoreButton = () =>
    this.viewMoreButton &&
    !this.state.isViewMoreButtonDismissed &&
    !this.state.isViewMoreButtonPositionEstablished;

  positionViewMoreButton() {
    if (!this.canMoveViewMoreButton()) {
      return;
    }

    if (this.areAllItemsInFirstLine()) {
      return this.setState({
        isViewMoreButtonPositionEstablished: true,
        isViewMoreButtonHidden: true
      });
    }

    const minimumVisibleItems = Math.min(
      this.props.minimumVisibleItems,
      this.props.itemCount
    );

    if (
      this.isElementInFirstLine(this.viewMoreButton) ||
      this.state.viewMoreButtonPosition === minimumVisibleItems
    ) {
      return this.setState({
        isViewMoreButtonPositionEstablished: true
      });
    }

    return this.setState({
      viewMoreButtonPosition: this.state.viewMoreButtonPosition - 1
    });
  }

  componentDidUpdate() {
    this.positionViewMoreButton();
  }

  canShowItems = () => this.props.itemCount > 0;

  setViewMoreButtonElement = elem => {
    this.viewMoreButton = elem;
  };

  render() {
    const { ListComponent } = this.props;

    return this.canShowItems() ? (
      <ListComponent
        showViewMore={this.canShowViewMoreButton()}
        onViewMoreButtonSet={this.setViewMoreButtonElement}
        viewMoreButtonPosition={this.state.viewMoreButtonPosition}
        onViewMoreButtonClicked={this.onViewMoreButtonClicked.bind(this)}
      />
    ) : null;
  }
}

ExpandableList.propTypes = {
  ListComponent: PropTypes.elementType.isRequired,
  itemCount: PropTypes.number.isRequired,
  minimumVisibleItems: PropTypes.number.isRequired,
  screenDimensions: PropTypes.object.isRequired
};

ExpandableList.defaultProps = {
  itemCount: 0,
  minimumVisibleItems: MINIMUM_VISIBLE_ITEMS_DEFAULT
};

const mapStateToProps = state => ({
  screenDimensions: state.layout.screenDimensions
});

export default connect(mapStateToProps)(ExpandableList);
